<template>
    <div>
        <modal
            centered
            :show.sync="localOpen"
            id="addCustomerList"
            bodyClasses="create-campaign-modal-body"
            footerClasses="border-top p-2">
            <!-- title -->
            <div slot="header" class="border-bottom pb-3 w-100">
                <h3 class="title title-up">Upload Customer List</h3>
            </div>
            <!-- title -->

            <!-- input filename and select client -->
            <div class="row col-sm-12 col-md-12 col-lg-12 d-flex align-items-center" style="gap:20px">
                <div class="w-100 col-12 col-md-6 col-lg-12">
                    <base-input
                        label="Customer List Name"
                        type="text"
                        placeholder="e.g., Summer campaign Audience"
                        :maxlength="56"
                        v-model="customerListName"
                        class="mb-0 pb-0"
                        @keyup="clearErrorInput('customerListName')">
                    </base-input>
                    <small style="color:#942434 !important;" v-if="err_customerListName">* Customer List Name Is Required</small>
                </div>
                <div class="w-0 col-12 col-md-6 col-lg-12 mb-3"> 
                    <label>{{isCompanyNamedisabled ? "Client Name" : "Select Client Name"}}</label>
                    <el-select
                        class="select__form__client w-100"
                        size="large"
                        placeholder="Select Client Name"
                        v-model="selectedUserId"
                        :disabled="isCompanyNamedisabled"
                        @change="clearErrorInput('selectedUserId')">
                        <el-option
                            v-for="option in companyList"
                            :value="option.id"
                            :label="option.company_name"
                            :key="option.id">
                        </el-option>
                    </el-select>
                    <small style="color:#942434 !important;" v-if="err_selectedUserId">* Client Name Is Required</small>
                </div>
            </div>
            <!-- input filename and select client -->

            <!-- download sample and upload file -->
            <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
                <div class="d-flex align-items-center justify-content-between">
                    <span class="font-weight-600 text-dark" style="font-size: 16px;">Local Customer List</span>
                    <a href="/samplefile/sample-customer-predict.csv" download>
                        <el-button class="upload-button" icon="el-icon-download" plain>
                            Download Sample CSV
                        </el-button>
                    </a>
                </div>

                <el-upload
                    action="#"
                    class="audiance-upload w-100 mt-2"
                    drag
                    ref="uploadCustomerList"
                    :auto-upload="false"
                    :file-list="fileList"
                    :on-change="handleChange">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text w-100">
                        Drop file here or <em>click to upload</em>
                    </div>
                    <div class="el-upload__tip d-flex flex-column" slot="tip">
                        <span>A csv file adhering to our format, see sample above.</span>
                        <span>Required fields: name, address, email, phone_number</span>
                        <span>Can only upload 1 file and maximum size 1 mb</span>
                    </div>
                </el-upload>
                <small style="color:#942434 !important;" v-if="err_uploadFile">* Upload File Is Required</small>
            </div>
            <!-- download sample and upload file -->

            <!-- checkbox aggree -->
            <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
                <el-checkbox
                    class="checkbox-advanced-information text-wrap d-flex align-items-center text-dark-50 --audiance-upload-aggrement"
                    style="font-size: 12px;"
                    label="By uploading physical addresses or other data, you warrant and represent that you (“customer”) own the information and have the right to collect and use the information for the marketing purposes in accordance with applicable laws."
                    v-model="isAggreed"
                    @change="clearErrorInput('isAggreed')">
                    By uploading physical addresses or other data, you warrant and
                    represent that you (“customer”) own the information and have the right
                    to collect and use the information for the marketing purposes in
                    accordance with applicable laws.
                </el-checkbox>
                <small style="color:#942434 !important;" v-if="err_aggreed">* Aggree Is Required</small>
            </div>
            <!-- checkbox aggree -->

            <!-- button upload and cancel -->
            <template slot="footer">
                <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex flex-row-reverse flex-wrap" style="gap:8px">
                    <base-button :disabled="isUploadCustomerList" size="sm" :id="'btnSave'" style="height:40px" @click="uploadCustomerList">
                        Upload <i v-if="isUploadCustomerList" class="fas fa-spinner fa-spin ml-2" style="font-size: 18px;"></i>
                    </base-button>
                    <base-button
                        :disabled="isUploadCustomerList"
                        @click="localOpen = false"
                        simple
                        size="sm"
                        style="height:40px">
                        Cancel
                    </base-button>
                </div>
            </template>
            <!-- button upload and cancel -->
        </modal>
    </div>
</template>

<script>
import { Modal } from "src/components";
import { Select, Option, Upload, Button, Checkbox, Notification } from "element-ui";
import axios from 'axios';

export default {
    // component
    components: {
        Modal,
        [Option.name]: Option,
        [Select.name]: Select,
        [Upload.name]: Upload,
        [Button.name]: Button,
        [Checkbox.name]: Checkbox
    },
    // component

    // data
    data() {
        return {
            customerListName: '',
            selectedUserId: '',
            isUploadCustomerList: false,
            fileList: [],
            isAggreed: false,
            err_customerListName: false,
            err_selectedUserId: false,
            err_uploadFile: false,
            err_aggreed: false,
        }
    },
    // data

    // props
    props: {
        value: { // v-model
            type: Boolean,
            required: true
        },
        userId: { // user id client
            type: [Number, String],
            required: true
        },
        isCompanyNamedisabled: { // company name disabled or not
            type: Boolean,
            required: true
        },
        companyList: { // list clients
            type: Array,
            required: true
        }
    },
    // props

    // computed
    computed: {
        localOpen: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    // computed
    
    // watch
    watch: {
        localOpen(newValue) {
            if (newValue) { // open
                this.selectedUserId = this.userId;
            } else { // closed
                this.$refs.uploadCustomerList.clearFiles();
                this.fileList = [];
            }
        }
    },
    // watch

    // methods
    methods: {
        notificationError(message) { // notify error
            setTimeout(() => {
                Notification({ 
                    message: `
                        <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                            <i class="el-notification__icon el-icon-error" style="margin-right: 10px;"></i> 
                            <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Error</span>
                        </p>
                        <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                            ${message || 'Server might be busy please try again later.'}
                        </p>
                    `,
                    duration: 4000,
                    dangerouslyUseHTMLString: true,
                })
            },1)
        },

        notificationSuccess(message) { // notify success
            setTimeout(() => {
                Notification({ 
                    message: `
                        <p style="display: flex; align-items: center; color: #000; font-size: 14px; font-weight: bold;">
                            <i class="el-notification__icon el-icon-success" style="margin-right: 10px;"></i> 
                            <span style="font-size: 16px; font-family: 'Poppins', sans-serif;">Success</span>
                        </p>
                        <p style="color: #000; font-size: 14px; margin-top: 10px; font-family: 'Poppins', sans-serif;">
                            ${message || 'Server might be busy please try again later.'}
                        </p>
                    `,
                    duration: 4000,
                    dangerouslyUseHTMLString: true,
                })
            },1)
        },

        clearAllInput() {
            this.customerListName= '',
            this.selectedUserId = this.userId,
            this.fileList = [],
            this.isAggreed = false,
            this.isUploadCustomerList = false,
            this.$refs.uploadCustomerList.clearFiles();
        },

        clearErrorInput(variableName) { // clear error input
            switch (variableName) {
                case 'customerListName': this.err_customerListName = false; break;
                case 'selectedUserId': this.err_selectedUserId = false; break;
                case 'upload':  this.err_uploadFile = false; break;
                case 'isAggreed':  this.err_aggreed = false; break;
            }
        },

        validationBeforeUpload() { // validation customerListName, selectedUserId
            let isSuccess = true;
            if (!this.customerListName || this.customerListName.trim() == '') {
                this.err_customerListName = true;
                isSuccess = false;
                this.notificationError('Customer List Name Is Required');
            }
            if (!this.selectedUserId) {
                this.err_selectedUserId = true;
                isSuccess = false;
                this.notificationError('Customer List Name Is Required');
            }
            if (this.fileList.length == 0) {
                this.err_uploadFile = true;
                isSuccess = false;
                this.notificationError('Upload File Is Required');
            }
            if (!this.isAggreed) {
                this.err_aggreed = true;
                isSuccess = false;
                this.notificationError('Please Check Aggree');
            }
            return isSuccess;
        },

        handleChange(file, fileList) { // ketika ada perubahan di componenet file
            // validation
            this.clearErrorInput('upload');
            
            const isFileCsv = file.type === 'text/csv' || file.name.endsWith('.csv');
            const isFileUnder1Mb = file.size / 1024 / 1024 <= 1;

            if (!isFileCsv || !isFileUnder1Mb) {
                // Hapus hanya file baru dari daftar file internal Element UI
                const lastIndex = this.$refs.uploadCustomerList.uploadFiles.length - 1;
                this.$refs.uploadCustomerList.uploadFiles.splice(lastIndex, 1); // hanya hapus yang baru
                
                const messageError = !isFileCsv ? 'file type must be csv.' : 'file size must be under or equal to 1mb.';
                return this.notificationError(messageError);
            }
            // validation

            // add file to list
            this.fileList = [file];
            this.$refs.uploadCustomerList.uploadFiles.splice(0, this.$refs.uploadCustomerList.uploadFiles.length); // bersihkan file internal di element ui nya
            
            // console.log('handleChange', {
            //     'file': file,
            //     'this.fileList': this.fileList,
            //     'this.$refs.uploadCustomerList.uploadFiles.length': this.$refs.uploadCustomerList.uploadFiles.length
            // });
            // add file to list
        },

        uploadCustomerList() { // untuk upload file csv
            // console.log('uploadCustomerList', {
            //   'fileList': this.fileList,
            //   'selectedUserId': this.selectedUserId // user id
            // });

            // validation
            if (!this.validationBeforeUpload()) {
                return;
            }
            // validation

            // process axios
            this.isUploadCustomerList = true;
            
            const formData = new FormData();
            formData.append('customer_list_name', this.customerListName);
            formData.append('user_id', this.selectedUserId);
            formData.append('file', this.fileList[0].raw);

            axios
            .post(`${process.env.VUE_APP_APISERVER_URL}/api/predict/customer/upload`, formData)
            .then(response => {
                this.localOpen = false;
                this.isUploadCustomerList = false
                this.$emit('upload-finished', response.data.customer_id);
                this.clearAllInput();
                this.notificationSuccess('add customer list successfully');
            })
            .catch(error => {
                const messageError = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'something wrong please try again';
                this.isUploadCustomerList = false;
                this.notificationError(messageError)
            })
            // process axios
        },
    },
    // methods
}
</script>

<style lang="scss">
.audiance-upload .el-upload-dragger {
  width: 100%;
}

.audiance-upload .el-upload {
  width: 100%;
}

.--audiance-upload-aggrement .el-checkbox__label {
  font-size: 12px;
  color: rgba(34, 42, 66, 0.5) !important;
}
</style>